import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { Text } from '../Text';
import { TextButton } from '../TextButton';
import { Button } from '../Button';
import { CloseButton } from '../CloseButton/CloseButton';
import { deprecationLog } from '../utils/deprecationLog';
import { TYPES, dataHooks } from './constants';
import { st, classes } from './FloatingNotification.st.css';
import { FloatingNotificationProps } from './FloatingNotification.types';

/**
 * @deprecated FloatingNotification is deprecated and will be removed in the next major version. Please use SectionHelper instead.
 */
class FloatingNotification extends React.PureComponent<FloatingNotificationProps> {
  static displayName = 'FloatingNotification';
  static defaultProps = {
    type: 'standard',
    buttonProps: {},
    textButtonProps: {},
    showCloseButton: true,
  };

  constructor(props: FloatingNotificationProps) {
    super(props);
    deprecationLog(
      '<FloatingNotification/> is deprecated and will be removed in the next major version. Please use <SectionHelper/> instead.',
    );
  }

  render() {
    const { type, className, dataHook, width, fullWidth } = this.props;
    const icon = this._getIcon();
    const content = this._getContent();
    const textButton = this._getTextButton();
    const button = this._getButton();
    const close = this._getClose();

    const style: { width?: string; maxWidth?: string } = { width };
    width && (style.maxWidth = width);

    return (
      <div
        data-hook={dataHook}
        className={st(classes.root, { fullWidth, type }, className)}
        style={style}
      >
        {icon}
        {content}
        {textButton}
        {button}
        <div className={classes.gap} />
        {close}
      </div>
    );
  }

  _getIcon() {
    const { prefixIcon, type } = this.props;
    return prefixIcon ? (
      <div className={st(classes.icon, { type })}>{prefixIcon}</div>
    ) : null;
  }

  _getContent() {
    const { text, type } = this.props;
    return (
      <Text
        size="small"
        ellipsis
        light={type === TYPES.dark}
        dataHook={dataHooks.notificationText}
        className={classes.text}
      >
        {text}
      </Text>
    );
  }

  _getTextButton() {
    const { textButtonProps, type } = this.props;
    const { label, ...rest } = textButtonProps ?? {};

    return !isEmpty(textButtonProps) ? (
      <TextButton
        {...rest}
        underline="always"
        skin={type !== TYPES.dark ? 'dark' : 'light'}
        size="small"
        className={classes.textButton}
        dataHook={dataHooks.textButton}
      >
        {label}
      </TextButton>
    ) : null;
  }

  _getButton() {
    const { buttonProps, type } = this.props;
    const { label, ...rest } = buttonProps ?? {};

    return !isEmpty(buttonProps) ? (
      <Button
        {...rest}
        className={classes.button}
        size="tiny"
        priority={type !== TYPES.dark ? 'secondary' : 'primary'}
        skin={type !== TYPES.dark ? 'dark' : 'standard'}
        dataHook={dataHooks.button}
      >
        {label}
      </Button>
    ) : null;
  }

  _getClose() {
    const { showCloseButton, onClose, type } = this.props;
    return showCloseButton ? (
      <CloseButton
        size="medium"
        skin={type !== TYPES.dark ? 'dark' : 'light'}
        className={classes.close}
        dataHook={dataHooks.closeButton}
        onClick={onClose}
      />
    ) : null;
  }
}

export { FloatingNotification };
